import styled, { css } from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  left: 90px;
  right: 60px;
  margin-top: -62px;

  ${media.medium`
    right: auto;
    left: calc(100% - 6vw);
    margin-top: -10vw;
  `}

  ${props => props.flipped && css`
    left: 0;
  `}
`;
